import React from 'react';
import Image from '../Image/Image';
import { getNumericNoiseClassType } from '../../../helpers/tiresHelper';

function LegacyTireLabel({ tireDetails }) {
    return (
        <div className="uk-margin-auto-left uk-margin-auto-right" style={{ maxWidth: 250 }}>
            <div>
                <Image
                    style={{ width: '56.5%' }}
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/reifenlabel/leftTop${tireDetails.rollingResistance}.png`}
                    alt="img_left_top"
                />
                <Image
                    style={{ width: '43.5%' }}
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/reifenlabel/rightTop${tireDetails.wetGrip}.png`}
                    alt="img_right_top"
                />
            </div>
            <div>
                <Image
                    style={{ width: ' 54.5%', maxHeight: 109 }}
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/reifenlabel/leftdown${getNumericNoiseClassType({
                        noiseClassType: tireDetails.noiseClassType,
                    })}.png`}
                    alt="img_left_bottom"
                />
                <Image
                    style={{ width: ' 45.5%', maxHeight: 109 }}
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/reifenlabel/rightdown${tireDetails.noisePerformance}.png`}
                    alt="img_right_bottom"
                />
            </div>
        </div>
    );
}

export default LegacyTireLabel;
